import {IMultiSelectSettings} from 'angular-2-dropdown-multiselect';

export const FILTER_STANDARD: IMultiSelectSettings = {
  buttonClasses: 'btn btn-default btn-tn btn-dropdown',
  dynamicTitleMaxItems: 1,
  displayAllSelectedText: true,
};

export const FILTER_SEARCH: IMultiSelectSettings = {
  enableSearch: true,
  buttonClasses: 'btn btn-default btn-tn btn-dropdown',
  dynamicTitleMaxItems: 1,
  displayAllSelectedText: true,
};
